import { ChildModel, ModelBase } from 'store/model-base';

import { LineDataPlan } from './line-data-plan';
import { AccountEligibilityStatus } from 'my-account/constants';

export class PlanEligibility extends ModelBase {
    public static storeName: string = 'planEligibility';
    public static idAttribute: string = 'lineKey';

    public lineKey: string;
    public plans: LineDataPlan[];
    public accountEligiblityStatus: AccountEligibilityStatus;

    public eligiblePlan: LineDataPlan;
    public isEligible: boolean;
    public isInEligible: boolean;
    public requiresUpgrade: boolean;
    public isIneligibleScheduledPlan: boolean;

    public static create<T extends ModelBase>(response: ApiResponse): T {
        const toReturn: PlanEligibility = super.create<PlanEligibility>(response);
        toReturn.eligiblePlan = toReturn.plans.find((plan: LineDataPlan) => plan.isEligible || plan.requiresUpgrade || plan.isIneligibleScheduled);
        toReturn.isEligible = Boolean(toReturn.eligiblePlan);
        toReturn.isInEligible = !toReturn.isEligible;
        toReturn.requiresUpgrade = toReturn.eligiblePlan && toReturn.eligiblePlan.requiresUpgrade;
        toReturn.isIneligibleScheduledPlan = toReturn.plans.some((plan: LineDataPlan) => plan.isIneligibleScheduled);

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'plans',
            model: LineDataPlan
        }];
    }
}
